import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import DeviceControl from "src/routes/devicecontrol";
import ReactModal from "react-modal"; // Import ReactModal
import Active from "../common/Active";
import NetInfo from "../common/NetInfo";
import { EllipsisVertical } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "../ui/command";
import { Zap, Moon, Satellite } from "lucide-react";
import Map from "react-map-gl/mapbox";
import mapboxgl from "mapbox-gl";
import DeviceList from "./DeviceList";
// [tutorial disabled] import { driver } from "driver.js";
// [tutorial disabled] import "driver.js/dist/driver.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "leaflet/dist/leaflet.css";
import L  from "leaflet";
import "src/styles/common/MapView.css";
import "react-toastify/dist/ReactToastify.css";
import { useApiFetch } from "src/lib/api";

const MapView = () => {
  const [devices, setDevices] = useState([]);
  const [camera, setCamera] = useState(false);
  const [product, setProduct] = useState("");
  const [loading, setLoading] = useState(true); // Estado de carga
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [selectedDeviceIp, setSelectedDeviceIp] = useState(null); // Selected device IP
  const [mapMode, setMapMode] = useState("default");
  const [selectedDevice, setSelectedDevice] = useState({
    ip: null,
    name: null,
    victron_id: null
  }); // Selected device (IP and name)
  const [open, setOpen] = useState(false);
  const [role, setRole] = useState("member");
  const [popupInfo, setPopupInfo] = useState(null);
  const mapRef = React.useRef();
  const layoutRef = React.useRef(null);
  const redMapRef = React.useRef();
  const apiFetch = useApiFetch();
  
  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] await apiFetch("/auth/disable-tutorial", { method: "POST" });
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  const handleClick = React.useCallback(
    (event) => {
      if (mapMode !== "red" || !redMapRef.current) return;

      const map = redMapRef.current.getMap();

      const padding = 10; // píxeles de radio alrededor del click
      const clickBox = [
        [event.point.x - padding, event.point.y - padding],
        [event.point.x + padding, event.point.y + padding],
      ];

      const features = map.queryRenderedFeatures(clickBox, {
        layers: ["spain", "germany","netherlands", "switzerland", "belgium", "italy", "andorra", "portugal", "france", "spain", "background"],
      });

      if (features.length > 0) {
        const feature = features[0];
        setPopupInfo({
          longitude: event.lngLat.lng,
          latitude: event.lngLat.lat,
          voltage: feature.properties.voltage || "Unknown",
          circuits: feature.properties.circuits || "Unknown",
          cables: feature.properties.cables || "Unknown",
          operator: feature.properties.operator || "Unknown",
          wires: feature.properties.wires || "Unknown",
          location: feature.layer.id || "Unknown",
        });
      } else {
        setPopupInfo(null);
      }
    },
    [mapMode]
  );

  // Function to open the modal with selected device's IP
  const openModal = (ip, name, victron_id) => {
    setSelectedDevice({ ip, name, victron_id });
    setIsModalOpen(true); // Open the modal
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDeviceIp(null);
  };

  async function updateVictronDevices() {
    try {
      const data = await apiFetch("/api/update-status-victron");
      if (!data) return null;
      return data; // Return data in case you want to use it later
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  // [tutorial disabled] /* Display tour tutorial */
   // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] let intervalId = null;

    // [tutorial disabled] const checkForTutorialReady = () => {
      // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
      // [tutorial disabled] const el = document.querySelector("#devices-map");

      // [tutorial disabled] if (step === "mapView" && el) {
        // [tutorial disabled] clearInterval(intervalId); 
        // [tutorial disabled] startDriver(); 

        // [tutorial disabled] setTimeout(() => {
          // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
        // [tutorial disabled] }, 1000);
      // [tutorial disabled] }
    // [tutorial disabled] };

    // [tutorial disabled] const startDriver = () => {
      // [tutorial disabled] const driverObj = driver({
        // [tutorial disabled] steps: [
          // [tutorial disabled] {
            // [tutorial disabled] element: "#devices-map",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Global Map",
              // [tutorial disabled] description: "Shows coordinates of all devices within the world map, the devices can be clicked more information",
              // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
                // [tutorial disabled] disableTutorial();
              // [tutorial disabled] },
              // [tutorial disabled] onPrevClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "org-space");
              // [tutorial disabled] }, 
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onHighlighted: () => {
              // [tutorial disabled] const enablePrev = () => {
                // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
                // [tutorial disabled] if (prevBtn) {
                  // [tutorial disabled] prevBtn.removeAttribute("disabled");
                  // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
                  // [tutorial disabled] clearInterval(retry); 
                // [tutorial disabled] }
              // [tutorial disabled] };

              // [tutorial disabled] const retry = setInterval(enablePrev, 100);
              // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] {
            // [tutorial disabled] element: "#mapMode-selector",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Map mode",
              // [tutorial disabled] description: "This is a selector for the different map modes",
              // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
                // [tutorial disabled] disableTutorial();
              // [tutorial disabled] }  
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] {
            // [tutorial disabled] element: ".multi-option-box",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Panel of global information",
              // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
                // [tutorial disabled] nextBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] onNextClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "active");
              // [tutorial disabled] },
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
                // [tutorial disabled] disableTutorial();
              // [tutorial disabled] }, 
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
          // [tutorial disabled] },
          
        // [tutorial disabled] ],
      // [tutorial disabled] });

      // [tutorial disabled] driverObj.drive();
    // [tutorial disabled] };

    // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

    // [tutorial disabled] return () => {
      // [tutorial disabled] if (intervalId) clearInterval(intervalId);
    // [tutorial disabled] };
  // [tutorial disabled] }, []);

  useEffect(() => {
    const fetchMap = async () => {
      try {
        const data = await apiFetch("/api/devices");
        if (!data) return;
        setDevices(data?.result ?? []); // Set devices state with the fetched data
        setCamera(data?.camera?.camera ?? false); // Set camera state with the fetched data
        setProduct(data?.product?.product ?? ""); // Set product with the fetched data
        setRole(data?.role ?? "member");
      } catch (error) {
        console.error("Error fetching devices:", error);
      } finally {
        setLoading(false); // Desactivar estado de carga
      }
    };
    fetchMap();
  }, [apiFetch, devices]);

  // Function to convert StatusIndicators to a custom icon
  const createStatusIcon = (status) => {
    if (mapMode !== "red") {
      return L.divIcon({
        html: `<div style="background-color: ${
          status === "online" ? "green" : "red"
        }; width: 15px; height: 15px; border-radius: 50%; border: 2px solid white;"></div>`,
        className: "", // Remove default icon styling
        iconSize: [10, 10], // Set appropriate size for your icons
        iconAnchor: [5, 5], // Anchor the icon in the center
      });
    }
  };

  const renderMapGLIcons = () => {
    console.log("[INFO] Rendering devices position on Map...");

    setTimeout(() => {
      const map = redMapRef?.current?.getMap();
      if (!map) {
        console.warn("Map not ready yet.");
        return;
      }

      const markerElements = document.getElementsByClassName("marker");
      while (markerElements[0]) {
        markerElements[0].remove();
      }

      (devices ?? []).forEach((device) => {
        if (device.latitude !== null && device.longitude !== null) {
          const el = document.createElement("div");
          el.className = "marker";
          el.style.backgroundColor =
            device.status === "online" ? "green" : "red";
          el.style.width = "15px";
          el.style.height = "15px";
          el.style.borderRadius = "50%";
          el.style.border = "2px solid white";
          el.style.cursor = "pointer";
          el.style.zIndex = "1000";
          el.onclick = () =>
            openModal(device.ip, device.name, device.victron_id);

          new mapboxgl.Marker(el)
            .setLngLat([device.longitude, device.latitude])
            .addTo(map);
        }
      });
    }, 2000);
  };

  // Leaflet only listens to window resizes: also refit the map when the layout changes
  // size (e.g. the sidebar is expanded/collapsed or the side panel moves below the map).
  useEffect(() => {
    const el = layoutRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(() => mapRef.current?.invalidateSize?.());
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handleDeviceClick = (device) => {
    if (device.latitude && device.longitude && mapRef.current) {
      mapRef.current.setView([device.latitude, device.longitude], 18);
    }
  };

  return (
    <div ref={layoutRef} className="map-container home-map-layout z-0">
      <MapContainer
        ref={mapRef}
        center={[40.416775, -3.70379]}
        zoom={6}
        minZoom={3}
        maxZoom={18}
        className="map-view rounded-md"
        maxBounds={[
          [-85, -180],
          [85, 180],
        ]}
        maxBoundsViscosity={1.0}
        worldCopyJump={false}
        id="devices-map"
      >
        {/* Show default map mode */}
        {mapMode === "default" && (
          <TileLayer
            url={`https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZW5lcmdpb3Rmcm9udGVuZCIsImEiOiJjbHpzZW1iODAwbTR5MmxzOXAyN3dvYmNzIn0.aTaAySaxXRyA_CmRNL8VDQ`}
            attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> contributors'
            noWrap={true}
            tileSize={512}
            zoomOffset={-1}
          />
        )}

        {/* Show dark map mode */}
        {mapMode === "dark" && (
          <TileLayer
            url={`https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZW5lcmdpb3Rmcm9udGVuZCIsImEiOiJjbHpzZW1iODAwbTR5MmxzOXAyN3dvYmNzIn0.aTaAySaxXRyA_CmRNL8VDQ`}
            attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> contributors'
            noWrap={true}
            tileSize={512}
            zoomOffset={-1}
          />
        )}

        {/* Show dark map mode with electric net */}
        {mapMode === "red" && (
          <>
            <Map
              ref={redMapRef}
              mapboxAccessToken={
                "pk.eyJ1IjoiZW5lcmdpb3Rmcm9udGVuZCIsImEiOiJjbHpzZW1iODAwbTR5MmxzOXAyN3dvYmNzIn0.aTaAySaxXRyA_CmRNL8VDQ"
              }
              initialViewState={{
                longitude: -3.70379,
                latitude: 40.416775,
                zoom: 6,
              }}
              minZoom={2}
              maxZoom={18}
              maxBounds={[
                [-180, -85],
                [180, 85],
              ]}
              style={{ width: "100%", height: "100vh" }}
              mapStyle="mapbox://styles/energiotfrontend/cmay0ukuz009d01r2bo98gm6o"
              config={{
			basemap: {
				show3dObjects: false
			}
	       }}
              onClick={handleClick}
            />
          </>
        )}

        {loading ? (
          <div className="loading-indicator">Loading...</div>
        ) : (
          (devices ?? []).map((device, index) => {
            if (
              device.latitude !== undefined &&
              device.longitude !== undefined &&
              mapMode !== "red"
            ) {
              return (
                <Marker
                  key={index}
                  position={[device.latitude, device.longitude]}
                  icon={createStatusIcon(device.status)} // Use StatusIndicators as the marker icon
                >
                  <Popup interactive={false}>
                    {device.name} {device.status}
                    <br />
                    {device.ip_address && `IP: ${device.ip_address}`}
                    {camera &&
                      role === "admin" &&
                      device.ip_address &&
                      !device.victron_id && (
                        <button
                          className="config_camera"
                          onClick={() =>
                            (window.location.href = `http://${device.ip_address}:8080/`)
                          }
                        >
                          Configure Gateways
                        </button>
                      )}
                    {camera &&
                      role === "admin" &&
                      device.ip_address &&
                      device.victron_id && (
                        <button
                          className="config_camera"
                          onClick={() =>
                            (window.location.href = `https://vrm.victronenergy.com/login`)
                          }
                        >
                          Access admin information
                        </button>
                      )}
                    {role === "admin" &&
                      !device.victron_id &&
                      (product === "both" || product === "audio") && (
                        <button
                          className="config_camera"
                          onClick={() =>
                            openModal(
                              device.ip_address,
                              device.name,
                              device.victron_id
                            )
                          }
                        >
                          Get Status
                        </button>
                      )}
                  </Popup>
                  <ReactModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    style={{
                      overlay: {
                        zIndex: 100000, // Ensure the modal shows above other elements
                        backgroundColor: "rgba(0, 0, 0, 0.35)", // Dark background for modal
                      },
                      content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "400px", // Adjust width if necessary
                        padding: "20px", // Add padding for proper display
                        borderRadius: "10px",
                      },
                    }}
                  >
                    {/* Show only the ControlESP32 component */}
                    {selectedDevice.ip &&
                      selectedDevice.victron_id === null && (
                        <DeviceControl
                          deviceIP={selectedDevice.ip}
                          onClose={closeModal}
                        />
                      )}
                    {selectedDevice.victron_id !== null && (
                      <DeviceControl
                        deviceIP={selectedDevice.ip}
                        victronID={selectedDevice.victron_id}
                        onClose={closeModal}
                      />
                    )}
                  </ReactModal>
                </Marker>
              );
            } 
          })
        )}
      </MapContainer>
      {/* Dots to open map selector*/}
      <div className="map-mode-selector relative">
        {" "}
        {/* Este div ayuda a posicionar el popover relativo a los 3 puntos */}
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <button id="mapMode-selector">
              <EllipsisVertical size={26} className="cursor-pointer" />
            </button>
          </PopoverTrigger>
          <PopoverContent
            id="mapMode-menu"
            className="w-[150px] p-2 absolute right-0 mt-2 z-[9999] dots-popover"
            side="bottom"
            align="end"
          >
            <Command>
              <CommandList>
                <CommandGroup>
                  <CommandItem
                    onSelect={() => {
                      setMapMode("default");
                      setOpen(false);
                      setPopupInfo(null);
                    }}
                  >
                    <Satellite />
                    Satellite
                  </CommandItem>
                  <CommandItem
                    onSelect={() => {
                      setMapMode("dark");
                      setOpen(false);
                      setPopupInfo(null);
                    }}
                  >
                    <Moon />
                    Dark Mode
                  </CommandItem>
                  <CommandItem
                    onSelect={() => {
                      setMapMode("red");
                      setOpen(false);
                      renderMapGLIcons();
                    }}
                  >
                    <Zap />
                    Electrical Grid
                  </CommandItem>
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
      </div>

      <div className="multi-option-box">
        <h2>Global information</h2>
        <div className="cards">
          <Active />
          {mapMode !== "red" && (
            <DeviceList devices={devices} onDeviceClick={handleDeviceClick} />
          )}
        </div>
        {mapMode === "red" && popupInfo && (
          <div
            onClose={() => setPopupInfo(null)}
            closeOnClick={false}
            className="popup z-50 "
          >
            <NetInfo
              operator={popupInfo.operator}
              voltage={popupInfo.voltage}
              circuits={popupInfo.circuits}
              cables={popupInfo.cables}
              wires={popupInfo.wires}
              location={popupInfo.location}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MapView;
